// src/components/flux/FluxToolbar.jsx
import React, { useState } from 'react';
//import './FluxToolbar.css';

const FluxToolbar = ({ onAddNode, onZoomIn, onZoomOut, onZoomReset, zoom }) => {
  const [showNodeTypes, setShowNodeTypes] = useState(false);
  
  // Tipos de nodos disponibles
  const nodeTypes = [
    { type: 'trigger', label: 'Disparador', description: 'Inicia el flujo (ej. mensaje recibido)' },
    { type: 'process', label: 'Proceso', description: 'Procesa información' },
    { type: 'decision', label: 'Decisión', description: 'Ramifica el flujo basado en condiciones' },
    { type: 'action', label: 'Acción', description: 'Ejecuta una acción externa' },
    { type: 'output', label: 'Salida', description: 'Envía una respuesta' }
  ];
  
  // Alternar menú de tipos de nodos
  const toggleNodeTypesMenu = () => {
    setShowNodeTypes(!showNodeTypes);
  };
  
  // Manejar la selección de un tipo de nodo
  const handleNodeTypeSelect = (type) => {
    onAddNode(type);
    setShowNodeTypes(false);
  };
  
  // Formatear el valor del zoom como porcentaje
  const formatZoom = () => {
    return `${Math.round(zoom * 100)}%`;
  };
  
  return (
    <div className="flux-toolbar">
      <div className="toolbar-section">
        <button 
          className="toolbar-button add-node-btn"
          onClick={toggleNodeTypesMenu}
          title="Añadir nodo"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="16" />
            <line x1="8" y1="12" x2="16" y2="12" />
          </svg>
          <span>Añadir Nodo</span>
        </button>
        
        {/* Menú desplegable para tipos de nodos */}
        {showNodeTypes && (
          <div className="node-types-menu">
            {nodeTypes.map((nodeType) => (
              <div 
                key={nodeType.type}
                className="node-type-option"
                onClick={() => handleNodeTypeSelect(nodeType.type)}
              >
                <div className={`node-type-icon ${nodeType.type}`}></div>
                <div className="node-type-info">
                  <div className="node-type-label">{nodeType.label}</div>
                  <div className="node-type-description">{nodeType.description}</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      
      <div className="toolbar-section">
        <button 
          className="toolbar-button save-btn"
          title="Guardar flujo"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z" />
            <polyline points="17 21 17 13 7 13 7 21" />
            <polyline points="7 3 7 8 15 8" />
          </svg>
          <span>Guardar</span>
        </button>
        
        <button 
          className="toolbar-button run-btn"
          title="Probar flujo"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <polygon points="5 3 19 12 5 21 5 3" />
          </svg>
          <span>Probar</span>
        </button>
      </div>
      
      <div className="toolbar-section zoom-controls">
        <button 
          className="toolbar-button zoom-out-btn"
          onClick={onZoomOut}
          title="Alejar"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="8" y1="12" x2="16" y2="12" />
          </svg>
        </button>
        
        <span className="zoom-value" onClick={onZoomReset} title="Restablecer zoom">
          {formatZoom()}
        </span>
        
        <button 
          className="toolbar-button zoom-in-btn"
          onClick={onZoomIn}
          title="Acercar"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="8" x2="12" y2="16" />
            <line x1="8" y1="12" x2="16" y2="12" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default FluxToolbar;